import { Component, OnInit, OnDestroy } from '@angular/core';
import { timer, Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'v2m-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  images = ['url(assets/teaser_home_2.jpg)', 'url(assets/teaser_home.jpg)'];
  teaserIndex = 0;
  timerSubscription: Subscription;

  constructor(private modalService: ModalService, private seo: SeoService) {}

  ngOnInit() {
    const source = timer(5000, 5000);
    this.timerSubscription = source.subscribe(val => {
      this.teaserIndex = (this.teaserIndex + 1) % this.images.length;
    });
    this.seo.updateKeywords(
      'video2manual,Video-Anleitung,Gebrauchsfilm,Utility Film'
    );
  }

  ngOnDestroy(): void {
    this.timerSubscription.unsubscribe();
  }

  openModal(id: string) {
    this.modalService.open(id);
  }

  closeModal(id: string) {
    this.modalService.close(id);
  }
}
